import React from 'react';
import { useToken } from '../hooks/useToken';
import { ENV } from '../config/env';

/**
 * Why this tab cannot use the exam page, or null when the token is usable.
 * The token only arrives with the portal launch link (#token=...) and is kept per tab, so a copied/bookmarked
 * address or a new tab has none; the page must not run with a placeholder user.
 */
export function examTokenProblem(decoded, role, nowMs = Date.now()) {
  if (!decoded || decoded.user_id == null || decoded.user_id === '') return 'missing';
  const exp = Number(decoded.exp);
  if (Number.isFinite(exp) && exp * 1000 < nowMs) return 'expired';
  const tokenRole = decoded.role === 'staff' ? 'staff' : 'student';
  if (tokenRole !== role) return 'wrong-role';
  if (role === 'student' && (decoded.registration_id == null || decoded.registration_id === '')) return 'missing';
  return null;
}

const MESSAGES = {
  missing: 'Your exam session was not found in this browser tab. Exam links work only when opened from the portal.',
  expired: 'Your exam session has expired.',
  'wrong-role': 'This link was opened with a session for a different page.',
};

export default function RequireExamToken({ role, children }) {
  const { decoded } = useToken();
  const problem = examTokenProblem(decoded, role);
  if (!problem) return children;

  const portal = ENV.PHP_API_BASE;
  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24, background: '#f5f7fb' }}>
      <div role="alert" style={{ maxWidth: 460, width: '100%', background: '#fff', borderRadius: 12, padding: 28, boxShadow: '0 4px 20px rgba(0,0,0,0.08)', textAlign: 'center' }}>
        <h2 style={{ margin: '0 0 12px', fontSize: 20 }}>Please open the exam again</h2>
        <p style={{ margin: '0 0 8px', color: '#444' }}>{MESSAGES[problem]}</p>
        <p style={{ margin: '0 0 20px', color: '#444' }}>Go back to the portal and click the exam link again.</p>
        {portal && (
          <button
            type="button"
            onClick={() => { window.location.href = portal; }}
            style={{ padding: '10px 22px', border: 0, borderRadius: 8, background: '#2563eb', color: '#fff', fontSize: 15, cursor: 'pointer' }}
          >
            Go to portal
          </button>
        )}
      </div>
    </div>
  );
}
